"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertEmptyObjectsWithDitto = exports.prependEmptyObject = exports.insertEmptyObjects = void 0;
var lodash_1 = require("lodash");
function insertEmptyObjects(arr, groupBy, prependEmptyObject) {
  if (prependEmptyObject === void 0) {
    prependEmptyObject = false;
  }
  if (arr.length === 0) {
    return [];
  }
  var result = [];
  var keys = Object.keys(arr[0]);
  var emptyObject = keys.reduce(function (acc, key) {
    /* @ts-ignore */
    acc[key] = '';
    return acc;
  }, {});
  var previousValue = arr[0][groupBy];
  result.push(arr[0]);
  if (prependEmptyObject) {
    result.push(emptyObject);
  }
  for (var i = 1; i < arr.length; i++) {
    var currentValue = arr[i][groupBy];
    if (currentValue !== previousValue) {
      // Create an empty object with the same keys as the previous record
      result.push(emptyObject);
      previousValue = currentValue;
    }
    result.push(arr[i]);
  }
  return result;
}
exports.insertEmptyObjects = insertEmptyObjects;
function prependEmptyObject(arr) {
  if (!arr.length) {
    return [];
  }
  var keys = Object.keys(arr[0]);
  var emptyObject = keys.reduce(function (acc, key) {
    /* @ts-ignore */
    acc[key] = '';
    return acc;
  }, {});
  return __spreadArray([emptyObject], __read(arr), false);
}
exports.prependEmptyObject = prependEmptyObject;
function insertEmptyObjectsWithDitto(arr, groupBy, dittoFields, dittoMark, dittoMarkRepeat, prependEmptyObject) {
  var e_1, _a;
  if (dittoMark === void 0) {
    dittoMark = '.';
  }
  if (dittoMarkRepeat === void 0) {
    dittoMarkRepeat = true;
  }
  if (prependEmptyObject === void 0) {
    prependEmptyObject = false;
  }
  if (arr.length === 0) {
    return [];
  }
  var result = [];
  var keys = Object.keys(arr[0]);
  var emptyObject = keys.reduce(function (acc, key) {
    /* @ts-ignore */
    acc[key] = '';
    return acc;
  }, {});
  if (prependEmptyObject) {
    result.push(emptyObject);
  }
  var previousValue = arr[0][groupBy];
  result.push(arr[0]);
  for (var i = 1; i < arr.length; i++) {
    var currentValue = arr[i][groupBy];
    if (currentValue !== previousValue) {
      // Create an empty object with the same keys as the previous record
      result.push(emptyObject);
      previousValue = currentValue;
    }
    // Create a new object based on the current record
    var currentObject = __assign({}, arr[i]);
    try {
      // Set ditto fields to "." if they didn't change
      for (var dittoFields_1 = (e_1 = void 0, __values(dittoFields)), dittoFields_1_1 = dittoFields_1.next(); !dittoFields_1_1.done; dittoFields_1_1 = dittoFields_1.next()) {
        var field = dittoFields_1_1.value;
        if (i > 0 && arr[i][field] === arr[i - 1][field]) {
          /* @ts-ignore */
          currentObject[field] = dittoMarkRepeat ? (0, lodash_1.repeat)(dittoMark, (0, lodash_1.toString)(arr[i][field]).length) : dittoMark;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (dittoFields_1_1 && !dittoFields_1_1.done && (_a = dittoFields_1.return)) _a.call(dittoFields_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    result.push(currentObject);
  }
  return result;
}
exports.insertEmptyObjectsWithDitto = insertEmptyObjectsWithDitto;